import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';

import { Keys } from '@holmescorp/common';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { I18nProperties, DefaultChildrenWNodeFactory } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { pathmap } from 'lcc-state';

import css from '../css/resource-parser.m.css';
import { publish } from '@holmescorp/pub-sub';
import { includes } from 'lodash-es';

export interface ResourceQuizProperties {
	xqa: string;
	path: string;
	quizid?: string;
	flags?: string[];
}

const factory = create({ theme }).properties<ResourceQuizProperties>();
export const ResourceQuiz = factory(({ children, properties, middleware: { theme } }) => {
	const { key, xqa, path, quizid, flags = [] } = properties();
	const themeCss = theme.classes(css);
	const role = includes(flags, 'ariaRoleListitem') ? 'listitem button' : 'button';
	return v(
		'span',
		{
			key,
			xqa,
			tabIndex: 0,
			role,
			classes: [themeCss.resourcelink],
			onclick: (event) => {
				event.stopPropagation();
				if (quizid) {
					publish(`site/quiz/${quizid}`);
				} else if (pathmap.has(`${path}`)) {
					const { view } = pathmap.get(`${path}`)!;
					view();
				}
			},
			onkeydown: (event) => {
				switch (event.key) {
					case Keys.Enter:
					case Keys.Space:
					case Keys.Spacebar: {
						event.preventDefault();
						if (quizid) {
							publish(`site/quiz/${quizid}`);
						} else if (pathmap.has(`${path}`)) {
							const { view } = pathmap.get(`${path}`)!;
							view();
						}
					}
				}
			}
		},
		children()
	);
});
